export enum OPTIMIZELY_FLAGS_ENUM {
  WISHLIST_ENTRY_POINTS = 'guest_engagement_wishlist_v2',
  TMS_GATEWAY_PROXY_ENDPOINT = 'gtm_google_gateway_phase_2',
}
